import { Shirt, Smartphone, Sparkles, Lamp, Footprints, Palette, Wheat, Baby, Tag } from "lucide-react";

const ICONS = { Shirt, Smartphone, Sparkles, Lamp, Footprints, Palette, Wheat, Baby, Tag };

export const CategoryIcon = ({ name, className = "h-5 w-5" }) => {
  const I = ICONS[name] || Tag;
  return <I className={className} />;
};
